import CategoryDetails = Office.CategoryDetails;
import AsyncResultStatus = Office.AsyncResultStatus;

class Outlook {
    public static getMessageMode(ctx: Office.Context) {
        if (ctx.mailbox.item)
            return "inReplyTo" in ctx.mailbox.item
                ? MessageMode.Compose
                : MessageMode.Read;
        return undefined;
    }

    public static setInLocalStorage(key: string, value: any) {
        const myPartitionKey = Office.context.partitionKey;

        const valueStr = JSON.stringify(value);

        // Check if local storage is partitioned. 
        // If so, use the partition to ensure the data is only accessible by your add-in.
        if (myPartitionKey) {
            localStorage.setItem(myPartitionKey + key, valueStr);
        } else {
            localStorage.setItem(key, valueStr);
        }
    }

    public static getFromLocalStorage<T>(key: string): T | undefined {
        const myPartitionKey = Office.context.partitionKey;

        // Check if local storage is partitioned.
        const valueStr = myPartitionKey
            ? localStorage.getItem(myPartitionKey + key)
            : localStorage.getItem(key);

        if (valueStr)
            return JSON.parse(valueStr) as T;
        else
            return null;
    }
}

export enum MessageMode {
    Read, Compose
}

export default Outlook;